import {
  Box, Tooltip,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Popover,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import styles from "../../../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  ActionMsg,
  AddButton,
  BootstrapDialog,
  BootstrapDialogTitle,
  Breadcrumb,
  CustomePopover,
  dateConversion,
  DateConversionOnEntryPage,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  HandleSort,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
import { editDeleteEci, getEciList } from "../../../actions/actions";
import emptyCylinderInspectionService from "../../../services/emptyCylinderInspection.Service";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import { Link } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import CustomPagination from "../../reusableComponent/CustomPagination";


const EmptyCylinderInspectionList = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;

  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const [open, setOpen] = useState(false);
  const [openOption, setOpenOption] = useState("");
  const [info, setInfo] = useState({});
  const totalCount = useSelector(state => state.eci.total_count || 0);
  const defaultRowsPerPage = useSelector(state => state.eci.rows_per_page || 15);
  // const rows = useSelector((state) => state.eci.eci);
  const [rows, setRows] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [searchKey, setSearchKey] = useState("");

  const fields = ['entry_no', "entry_date", "cylinder_count","done_by","shift","shift_time","done_by"];
  const labels = ['entry No', "Entry Date", "No Of cylinder" ,"Inspection Done by","shift","shift time","From Plant"];
  const [openDialog, setOpenDialog] = useState(false);
  const [customermap, setCustomer] = useState([]);
  const [successMessage, setSuccessMessage] = useState(null);

  const respMsgState = useSelector((state) => state.eci.message);
  const [selectedCylinderDetails, setSelectedCylinderDetails] = useState([]);
   const [dialogTitle, setDialogTitle] = useState("Cylinder Details");
    const [openCylinderDialog, setOpenCylinderDialog] = useState(false);
    const [total_count,setTotalCount]=useState(null)
    useEffect(() => {
      setTotalCount(rows[0]?.totalCount);
    }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage
  });
  useEffect(() => {
    setController(prev => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);


  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      };
      const response = await emptyCylinderInspectionService.getEciList(params);
      setRows(response);
    } catch (error) {
      setSuccessMessage("Error fetching data");
    }
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setSearchKey(searchValue);  // Set the search key

    // Prepare the params based on the search value
    const params = {
      page: controller.page,
      size: searchValue === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
      searchKey: searchValue,
    };

    try {
  
      await fetchData(params);
    } catch (error) {
      console.error("Error in handleSearch:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [controller]);


  const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData, null, setSuccessMessage, respMsgState);
  // useEffect(() => {
  //   if (respMsgState) {
  //     setSuccessMessage(respMsgState);
  //   }
  // }, [respMsgState]);

  // useEffect(() => { }, [shouldShowMsg, responseMessage]);

  const deleteRecord = async (id) => {
    try {
      await emptyCylinderInspectionService.editDeleteEci({
        inspection_id: id,
        changedUpdatedValue: "delete"
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };

  const handleDelete = (functions) => {
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
    setOpen(false);
  };



  // Sort rows by entry_date descending
  const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
  // Calculate pagination info
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


  console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });



  const entryNoCylinderCount = {};
  rows.forEach(row => {
    const entry = row.entry_no;
    entryNoCylinderCount[entry] = row.cyl_no?.length || 0;
  });


  const handleOpenDialog = (row) => {
    setSelectedRow(row);
    setSelectedCylinderDetails(safeParse(row.tableData));
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setSelectedCylinderDetails([]);
  };

  const safeParse = (jsonString) => {
    if (jsonString && typeof jsonString === "string") {
      try {
        return JSON.parse(jsonString);
      } catch (e) {
        console.error("Error parsing JSON", e);
        return [];
      }
    }
    return [];
  };
 const handleCylinderCountClick = (row) => {
  try {
    const details = JSON.parse(row.tableData || '[]'); // Use tableData
    setSelectedCylinderDetails(details);
    setDialogTitle(`Cylinder Details for ${row.entry_no}`);
    setOpenCylinderDialog(true);
  } catch (error) {
    console.error("Error parsing tableData:", error);
    setSuccessMessage("Error loading cylinder details");
    setSelectedCylinderDetails([]);
  }
};
const getCylinderCount = (row) => {
  
  if (row.cylinder_count) {
    return row.cylinder_count;
  }

  try {
    const details = JSON.parse(row.tableData || '[]');
    return details.length || 0;
  } catch (error) {
    console.error("Error parsing child_details:", error);
    return 0;
  }
};
    const handleCloseCylinderDialog = () => {
    setOpenCylinderDialog(false);
    setSelectedCylinderDetails([]);
    setDialogTitle("Cylinder Details");
  }
  const getOwnerDisplay = (cylinder) => {
  if (!cylinder) return 'N/A';
  const { owner, customer_id } = cylinder;
  if (owner === 'TGPL') return 'TGPL';
  if (owner === 'customer' && customer_id && customermap[customer_id]) {
    return customermap[customer_id];
  }
  return owner || 'N/A'; 
};

  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb
          routeSegments={[
            { name: "Empty Cylinder Inspection List" },
          ]}
        />


        <HeaderSection
          title="INSPECTION LIST"
          addNewPath="/storeEntries/add-eci"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={fields}
          labels={labels}
          filename="Charges List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
          openscanner={false}
        />


        <Paper sx={{ width: '100%', }}>
          <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>

                  <StyledTableCell align="left"
                    className={`${styles.table_head}`}
                    onClick={() =>
                      HandleSort("entry_no", sortBy, setSortBy, rows)
                    }
                  >
                    Entry No
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "entry_no" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell align="left"
                    className={`${styles.table_head}`}
                    onClick={() =>
                      HandleSort("entry_date", sortBy, setSortBy, rows)
                    }
                  >
                    Date
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "entry_date" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell align="center"
                    className={`${styles.table_head}`}
                    onClick={() =>
                      HandleSort("cyl_no", sortBy, setSortBy, rows)
                    }
                  >
                    NO Of Cylinder
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "cyl_no" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort("done_by", sortBy, setSortBy, rows)}>
                    Inspection Done By
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "done_by" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort("shift", sortBy, setSortBy, rows)}>
                    Shift
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "shift" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort("shift_time", sortBy, setSortBy, rows)}>
                    Shift Time
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "shift_time" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>
                  {/* <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort("from_plant_name", sortBy, setSortBy, rows)}>
                 From Plant
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "from_plant_name" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell> */}









                  {/* <StyledTableCell align="center" className={`${styles.table_head}`}>
                    Action
                  </StyledTableCell> */}
                </StyledTableRow>
              </TableHead>
              <TableBody sx={{ backgroundColor: '#fff' }}>
                {Array.isArray(rows) &&
                  rows.map((row, index) => (
                    <StyledTableRow
                      key={row.name || index}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                        <Typography
                          sx={{ fontSize: "12px", cursor: "pointer", color: "#1976d2", }}
                          onClick={() => handleOpenDialog(row)}
                        >
                          {row.entry_no}
                        </Typography>
                      </StyledTableCell>
                    <StyledTableCell align="left" className={styles.list_table_body}>
  {row.entry_date ? new Intl.DateTimeFormat('en-GB').format(new Date(row.entry_date)) : "N/A"}
</StyledTableCell>

                      <StyledTableCell align="center" className={`${styles.list_table_body}`}>
  <Tooltip title="Click here to view cylinder details" arrow>
    <span
      onClick={() => handleCylinderCountClick(row)}
      style={{ cursor: 'pointer' }}
    >
      {getCylinderCount(row)} 
    </span>
  </Tooltip>
</StyledTableCell>



                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                          {row.inspection_done_by || row.done_by || 'N/A'}
                      </StyledTableCell>

                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                        {row.shift}
                      </StyledTableCell>

                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                        {row.shift_time}
                      </StyledTableCell>
                      {/* <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                     {row.inspection_done_by || row.done_by || 'N/A'}
                      </StyledTableCell> */}

                      {/* <StyledTableCell align="center">
                        <CustomePopover
                          row={row}
                          handleDelete={false}
                          linkTo="/storeEntries/add-eci"
                          showEdit={false}
                          handlePrint={false}
                             handleCancel={false}

                        />
                      </StyledTableCell> */}
                    </StyledTableRow>
                  ))}
              </TableBody>

            </Table>
          </TableContainer>
                                    <CustomPagination
  page={controller.page}
  rowsPerPage={controller.rowsPerPage}
  totalCount={total_count || 0}
  onPageChange={(newPage) => handleChangePage(null, newPage)}
/>
        </Paper>

        {/* ── CYLINDER INSPECTION DETAILS (Redesigned like Sales Order) ── */}
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth={false}
          sx={{
            "& .MuiDialog-paper": {
              margin: "auto",
              width: "92vw",
              maxHeight: "85vh",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              overflow: "hidden",
              fontFamily: "'Inter', Arial, sans-serif",
         
            },
          }}
        >
          {/* ── Dialog Header (Navy) ── */}
          <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.5px", fontFamily: "'Inter', Arial, sans-serif" }}>
              CYLINDER INSPECTION DETAILS
            </Typography>
            <IconButton onClick={handleCloseDialog} sx={{ color: "#fff", p: 0.5 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={{ padding: "20px 24px", background: "#F4F7FB", overflowY: "auto" }}>

            {/* ── Inspection Information Card ── */}
            <Box sx={{ background: "#fff", border: "1px solid #E2E8F0",  overflow: "hidden", mb: 2.5 }}>
              <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "0.4px" }}>
                  📋  Inspection Information
                </Typography>
              </Box>

              <Box>
                <Grid container>
                  {/* Row 1 */}
                  <Grid item xs={12} sm={6} md={2} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Entry No</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#1C3A5E", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.entry_no || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Entry Date</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{dateConversion(selectedRow?.entry_date)}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Shift</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.shift || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Shift Time</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.shift_time || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>Done By</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.inspection_done_by || selectedRow?.done_by || "N/A"}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2} sx={{ borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>From Depot</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>{selectedRow?.inspection_done_by || selectedRow?.done_by || "N/A"}</Typography>
                  </Grid>
                </Grid>
              </Box>
            </Box>

            {/* ── Cylinder Details Table ── */}
            <Box sx={{ background: "#fff", border: "1px solid #E2E8F0",  overflow: "hidden" }}>
           
              <TableContainer sx={{ maxHeight: "400px" }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <StyledTableRow>
                      {[
                        "Sr No", "Cylinder No", "Tag No", "Owner", "Valve Condition", 
                        "Fusible Plug", "Painting", "Cyl Cap Avl", "Result", 
                        "Actual Tare Wt", "Current Wt", "Wt After Solvent", 
                        "Qty Of Solvent", "Acetone Drum Tag No"
                      ].map((header) => (
                        <StyledTableCell
                          key={header}
                          align="center"
                          sx={{
                            backgroundColor: "#1C3A5E !important",
                            color: "#fff !important",
                            fontFamily: "'Inter', Arial, sans-serif",
                            fontWeight: 700,
                            fontSize: "11px", // Font size thoda chota kiya kyunki 14 columns hain
                            padding: "10px 8px",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid rgba(255,255,255,0.1)",
                          }}
                        >
                          {header}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {selectedCylinderDetails.length > 0 ? (
                      selectedCylinderDetails.map((row, index) => (
                        <StyledTableRow
                          key={index}
                          sx={{
                            backgroundColor: index % 2 === 0 ? "#fff" : "#F8FAFC",
                            "&:hover": { backgroundColor: "#EBF4FF" },
                          }}
                        >
                          {[
                            index + 1,
                            row.cylinder_no || "N/A",
                            row.tag_no || "N/A",
                            row.owner === "TGPL"
                              ? "TGPL"
                              : row.customer_id
                              ? customermap[row.customer_id] || "Customer"
                              : "N/A",
                            row.valve_condition || "N/A",
                            row.fusible_plug || "N/A",
                            row.painting || "N/A",
                            row.cyl_cap_avl || "N/A",
                            row.eci_result || "N/A",
                            row.current_tare_wt || "N/A",
                            row.actual_tare_wt || "N/A",
                            row.actual_tare_wt_aft_sol || "N/A",
                            Number(row.qty_solvent).toFixed(2) || "0.00",
                            row.acetone_drum_tag_no || "N/A"
                          ].map((val, ci) => (
                            <StyledTableCell
                              key={ci}
                              align="center"
                              sx={{
                                fontSize: "11px", // Chota font for 14 columns
                                fontFamily: "'Inter', Arial, sans-serif",
                                color: "#2D3748",
                                padding: "8px 6px",
                                borderBottom: "1px solid #EDF2F7",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val}
                            </StyledTableCell>
                          ))}
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell
                          colSpan={14}
                          align="center"
                          sx={{ py: 5, fontSize: "13px", color: "#A0AEC0", fontFamily: "'Inter', Arial, sans-serif" }}
                        >
                          No cylinder details available
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

          </DialogContent>

          {/* ── Dialog Footer ── */}
          <Box sx={{ padding: "12px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={handleCloseDialog}
              sx={{
                background: "#E53E3E",
                color: "#fff",
                fontSize: "13px",
                fontWeight: 600,
                textTransform: "none",
                padding: "7px 20px",
                borderRadius: "8px",
                fontFamily: "'Inter', Arial, sans-serif",
                "&:hover": { background: "#971f16" },
              }}
            >
              Close
            </Button>
          </Box>
        </Dialog>

        <Dialog
          open={openCylinderDialog}
          onClose={handleCloseCylinderDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {dialogTitle}
            <IconButton aria-label="close" onClick={handleCloseCylinderDialog}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Table size="small">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>Cylinder No</StyledTableCell>
                  <StyledTableCell>Tag No</StyledTableCell>
                  <StyledTableCell>Owner</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {selectedCylinderDetails.length > 0 ? (
                  selectedCylinderDetails.map((cylinder, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell>{cylinder.cylinder_no || 'N/A'}</StyledTableCell>
                      <StyledTableCell>{cylinder.tag_no || 'N/A'}</StyledTableCell>
                      <StyledTableCell>{getOwnerDisplay(cylinder)}</StyledTableCell>
                    </StyledTableRow>
                  ))
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={3} align="center">
                      No cylinder details available
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </DialogContent>
        </Dialog>


        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.inspection_id || null}
          displayName={deleteInfo?.inspection_id || ""}
        />
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
        <BootstrapDialog
          PaperProps={{
            sx: {
              minWidth: openOption === "Details" ? "95%" : "60%",
              maxHeight: "90%",
            },
          }}
          onClose={handleClose}
          open={open}
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
          >
            {openOption === "Details" ? "View Empty Cylinder Inspection Details" : ``}
          </BootstrapDialogTitle>
          <DialogContent dividers>
          </DialogContent>
        </BootstrapDialog>
      </Box>
    </Box>
  );
};
export default EmptyCylinderInspectionList;